export default {
  gutterBottom: {
    marginBottom: 15
  }
};
